var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{directives:[{name:"gl-tooltip",rawName:"v-gl-tooltip.hover",modifiers:{"hover":true}}],attrs:{"loading":_vm.isLoading,"title":_vm.buttonLabel,"category":"secondary","aria-label":_vm.buttonLabel},on:{"click":_vm.onToggle}},[_c('gl-icon',{class:{ 'gl-fill-blue-500': _vm.pendingTodo },attrs:{"name":_vm.buttonIcon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }